<template>
  <layout class="captain-payment-list-details-container">
    <div class="w-full flex flex-row adm-container">
      <div class="h-full flex flex-col sm:w-full md:w-3/4 lg:w-1/2">
        <router-link
          :to="previousURL"
          class="w-full mb-5 text-base text-black font-bold no-underline"
        >
          <i class="fa fa-angle-left mr-2" />
          <span>Back to list</span>
        </router-link>
        <div class="w-full flex flex-col">
          <div class="w-full flex flex-row mb-4">
            <div class="w-1/2 font-bold">
              Requested Vehicle
            </div>
            <div class="w-1/2 h-full uppercase">
              {{ trip.vehicle_type }}
            </div>
          </div>
          <div class="w-full flex flex-row mb-4">
            <div class="w-1/2 font-bold">
              Trip Id
            </div>
            <div class="w-1/2">
              {{ trip.hashed_trip_id }}
            </div>
          </div>
          <div class="w-full flex flex-row mb-4">
            <div class="w-1/2 font-bold">
              Registration No.
            </div>
            <div class="w-1/2 h-full">
              {{ trip.vehicle_reg_number }}
            </div>
          </div>
        </div>
        <div class="rounded border border-grey-light flex flex-col p4 trip-detail-container__inner relative">
          <div class="w-full text-center flex flex-col justify-center my-5">
            <div class="title uppercase mb-2">Earning</div>
            <div class="earning-amount text-primary text-4xl">
              <span class="font-bold">৳ {{ trip.earning || 0 }}</span>
            </div>
          </div>
          <div class="trip-details w-full flex flex-col">
            <div class="trip-details-heading flex flex-row text-lg w-full bg-white p-5">
              <div class="heading w-1/2">Trip Detail</div>
              <div class="date w-1/2 text-right">{{ trip.start_time }}</div>
            </div>

            <div class="trip-cash-details flex flex-row font-bold w-full py-2 px-8">
              <div
                v-if="trip.payment_type == 1"
                class="heading w-1/2"
              >Cash Collected</div>
              <div
                v-if="trip.payment_type == 2"
                class="heading w-1/2"
              >Collected via Wallet</div>
              <div class="date w-1/2 text-right">৳{{ trip.cash_collected || 0 }}</div>
            </div>

            <div class="trip-earning-details flex flex-col w-full bg-white py-2 px-8 border-t border-b border-solid border-grey-light">
              <div class="trip-earning-heading heading w-full my-2 font-bold">Trip Earnings</div>
              <div class="fare w-full flex flex-row my-2">
                <div class="title w-1/2">Fare</div>
                <div class="amount w-1/2 text-right">৳ {{ trip.fare || 0 }}</div>
              </div>
              <div class="pathao-fee w-full flex flex-row my-2">
                <div class="title w-1/2">Pathao Fee</div>
                <div class="amount w-1/2 text-right">৳ {{ trip.pathao_fee || 0 }}</div>
              </div>
              <div class="total w-full flex flex-row py-2 border-t border-solid border-grey-light font-bold">
                <div class="title w-1/2">Total Earnings</div>
                <div class="amount w-1/2 text-right">৳ {{ trip.earning || 0 }}</div>
              </div>
            </div>

            <div class="trip-duration-distance flex flex-row w-full bg-white border-b border-solid border-grey-light text-center">
              <div class="trip-duration flex flex-col w-full border-r border-solid border-grey-light py-5">
                <div class="heading text-grey-dark uppercase mb-2">Duration</div>
                <div class="time font-medium text-lg">{{ trip.duration_in_min || 0 }} min</div>
              </div>

              <div class="trip-details-heading flex flex-col w-full py-5">
                <div class="heading text-grey-dark uppercase mb-2">Distance</div>
                <div class="distance font-medium text-lg">{{ trip.distance_in_km || 0 }} km</div>
              </div>
            </div>

            <img :src="trip['map_static_url']">

            <div class="trip-duration-distance flex flex-row w-full bg-white border-b border-solid border-grey-light ">

              <div
                v-if="trip && trip.pickup_address && trip.dropoff_address"
                class="w-1/6 relative flex flex-col items-center justify-center">
                <div class="w-6 h-6 border border-primary rounded-full flex items-center justify-center">
                  <div class="w-4 h-4 bg-primary rounded-full" />
                </div>
                <div class="w-px h-12 bg-primary" />
                <div class="w-6 h-6 border border-primary rounded-full flex items-center justify-center">
                  <div class="w-4 h-4 bg-primary rounded-full" />
                </div>
              </div>

              <div class="w-5/6">
                <div class="trip-address flex flex-col w-full border-r border-solid border-grey-light py-5">
                  <div class="time font-bold mb-1">{{ trip.start_time }}</div>
                  <div class="address">{{ trip.pickup_address }}</div>
                </div>

                <div class="trip-address flex flex-col w-full border-r border-solid border-grey-light py-5">
                  <div class="time font-bold mb-1">{{ trip.end_time }}</div>
                  <div class="address">{{ trip.dropoff_address }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import Layout from '@layouts/main';
import makeRequest from '../../../../utils/apiRequest';
import Config from '../../../../config';

export default {
  name: 'TripDetails',
  page: {
    title: 'Trip Details',
  },
  components: { Layout },
  data() {
    return {
      trip: {},
      isFetchingData: false,
    };
  },
  computed: {
    previousURL() {
      const driverId = this.trip.driver_id;
      return driverId ? `/captain-management/payment-statements/driver-trips/${driverId}/start/${this.$route.params.startDate}/end/${this.$route.params.endDate}` : null;
    },
  },
  mounted() {
    this.fetchTripDetail();
  },
  methods: {
    fetchTripDetail() {
      if (!this.$route.params.tripId) {
        this.$notification.error('Error in getting trip detail');
        return;
      }

      const tripDetailMeta = {
        url: `${Config.api.baseURL}api/partners/trips/${this.$route.params.tripId}`,
      };

      this.isFetchingData = true;

      makeRequest(tripDetailMeta)
        .then((listResponse) => {
          this.trip = listResponse.data;
          this.isFetchingData = false;
        })
        .catch((errorResponse) => {
          this.$notification.error('Error in getting trip detail');
        });
    },
  },
};
</script>
